import gql from "graphql-tag";
import PropTypes from "prop-types";
import sortby from "lodash.sortby";

export default {
  query: gql`
    query processingUsers(
      $username: String
      $isBlocked: Boolean
      $rowFrom: Int
      $rowTo: Int
    ) {
      processingUsers(
        username: $username
        isBlocked: $isBlocked
        rowFrom: $rowFrom
        rowTo: $rowTo
      ) {
        id: username
        isBlocked
        comment
        currentRow
        totalRows
        roles {
          roleName
          comment
          accesses {
            id
            objectType
            objectValue
            rangeStart
            rangeEnd
            hasAccess
          }
        }
        accesses {
          id
          objectType
          objectValue
          rangeStart
          rangeEnd
          hasAccess
        }
      }
    }
  `,
  variables: ({ username, isBlocked, page = 1, itemsPerPage = 10 }) => {
    const start = (page - 1) * itemsPerPage || 1;
    return {
      username,
      isBlocked,
      rowFrom: start,
      rowTo: start + itemsPerPage,
    };
  },
  config: {
    pollInterval: 300000,
    errorPolicy: "none",
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "network-only",
  },
  propTypes: {
    username: PropTypes.string,
    isBlocked: PropTypes.bool,
    page: PropTypes.number,
    itemsPerPage: PropTypes.number,
  },
  dataKey: "processingUsers",
  sort: (items) => sortby(items, (o) => parseInt(o.id, 10)),
};



// WEBPACK FOOTER //
// ./src/model/gql/queries/processingUsers.js